import {createOne, deleteOne, getAllBy, getOne, getOneBy, updateOne} from './Api.js';

const MODULE = 'vote';

export function getVote(id) {
	return getOne(MODULE, id);
}

export function getVotesBy(property, value) {
	return getAllBy(MODULE, property, value);
}

export function getVoteByEntity(entityName, entityId) {
	return getOneBy(MODULE, entityName, entityId);
}

export function updateVote(data) {
	return updateOne(MODULE, data);
}

export function createVote(data) {
	return createOne(MODULE, data);
}

export function deleteVote(id) {
	return deleteOne(MODULE, id);
}
